<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >系统设置</span
      >
      / 主页设置
    </div>
    <el-tabs class="wrapper" v-model="activeName">
      <el-tab-pane label="基础设置" name="set0">
        <logoset
          :logo_img="logo_img"
          :contant_img="contant_img"
          :homepage_id="homepage_id"
          :is_show_copy_right="is_show_copy_right"
        ></logoset>
      </el-tab-pane>

      <el-tab-pane label="顶部轮播" name="set1">
        <carousel
          :homepageBanner="homepageBanner"
          :homepage_id="homepage_id"
          :is_show_banner_button="is_show_banner_button"
        ></carousel>
      </el-tab-pane>

      <el-tab-pane label="关于我们" name="set2">
        <aboutus
          :aboutus_img_url="aboutus_img_url"
          :aboutus_is_show="aboutus_is_show"
          :schoolData="schoolData"
          :aboutus_title_one="aboutus_title_one"
          :aboutus_title_two="aboutus_title_two"
          :aboutus_content="aboutus_content"
          :aboutus_imgup_url="aboutus_imgup_url"
          :aboutus_imgdown_url="aboutus_imgdown_url"
          :homepage_id="homepage_id"
        >
        </aboutus>
      </el-tab-pane>
      <el-tab-pane label="课程体系" name="set3">
        <courses
          :system_is_show="system_is_show"
          :homepageSystem="homepageSystem"
          :homepage_id="homepage_id"
          :system_title_one="system_title_one"
          :system_title_two="system_title_two"
          :system_content="system_content"
        >
        </courses>
      </el-tab-pane>
      <el-tab-pane label="教学理念" name="set4">
        <ideas
          :idea_is_show="idea_is_show"
          :ideaData="ideaData"
          :homepage_id="homepage_id"
        ></ideas>
      </el-tab-pane>
      <!--
      <el-tab-pane label="校园简介" name="set5">
        <school :schoolData="schoolData" :homepage_id="homepage_id"></school>
      </el-tab-pane>
      -->
      <el-tab-pane label="师资力量" name="set6">
        <teachers
          :teacher_is_show="teacher_is_show"
          :homepageTeacher="homepageTeacher"
          :homepage_id="homepage_id"
          :teacher_title_one="teacher_title_one"
          :teacher_title_two="teacher_title_two"
        ></teachers>
      </el-tab-pane>
      <el-tab-pane label="校园新闻" name="set7">
        <news
          :news_is_show="news_is_show"
          :homepageNews="homepageNews"
          :news_title_two="news_title_two"
          :news_title_one="news_title_one"
          :homepage_id="homepage_id"
        ></news>
      </el-tab-pane>
      <el-tab-pane label="学编程好处" name="set8">
        <reasons
          :whylearn_is_show="whylearn_is_show"
          :homepageWhyLearn="homepageWhyLearn"
          :whylearn_title_one="whylearn_title_one"
          :whylearn_title_two="whylearn_title_two"
          :homepage_id="homepage_id"
        >
        </reasons>
      </el-tab-pane>

      <el-tab-pane label="照片墙" name="set9">
        <photos
          :stu_is_show="stu_is_show"
          :homepageStu="homepageStu"
          :homepage_id="homepage_id"
          :stu_title_one="stu_title_one"
          :stu_title_two="stu_title_two"
        ></photos>
      </el-tab-pane>
      <el-tab-pane label="其他" name="set11">
        <Recommendedbyexperts
          :is_show_recommend="is_show_recommend"
          :homepage_id="homepage_id"
        ></Recommendedbyexperts>
        <commonproblem
          :is_show_problem="is_show_problem"
          :homepage_id="homepage_id"
        ></commonproblem>
      </el-tab-pane>

      <el-tab-pane label="Footer设置" name="set10">
        <footers
          :footer_is_show="footer_is_show"
          :homepageFooterMatch="homepageFooterMatch"
          :homepage_id="homepage_id"
          :aboutusData="aboutusData"
          :contantData="contantData"
          :qrcodeData="qrcodeData"
          :footer_match_title="footer_match_title"
        ></footers>
      </el-tab-pane>
      <el-tab-pane label="自定义导航" name="set12">
        <Nav
          :self_header_button="self_header_button"
          :homepage_id="homepage_id"
        ></Nav>
      </el-tab-pane>
    </el-tabs>

    <!--修改轮播图-弹窗-->
  </div>
</template>

<script>
import { getHomepage } from '@/api/homeset'

import carousel from './components/carousel'
import aboutus from './components/aboutus'
import courses from './components/courses'
import ideas from './components/ideas'
//import school from "./components/school";
import teachers from './components/teachers'
import news from './components/news'
import reasons from './components/reasons'
import photos from './components/photos'
import footers from './components/footers'
import logoset from './components/logoset'
import Nav from './components/Nav'

import Recommendedbyexperts from './components/Recommendedbyexperts'
import commonproblem from './components/commonproblem'

export default {
  name: 'homecarousel',
  components: {
    carousel: carousel,
    aboutus: aboutus,
    courses: courses,
    ideas: ideas,
    //school: school,
    teachers: teachers,
    news: news,
    reasons: reasons,
    photos: photos,
    footers: footers,
    logoset: logoset,
    Recommendedbyexperts: Recommendedbyexperts,
    commonproblem: commonproblem,
    Nav: Nav,
  },
  data() {
    return {
      self_header_button: [],
      activeName: 'set0',
      homepageBanner: [],
      homepage_id: null,
      is_show_banner_button: false,

      //LOGO和联系人
      logo_img: '',
      contant_img: '',
      is_show_copy_right: false, //是否显示备案信息
      //关于我们
      aboutus_title_one: '',
      aboutus_title_two: '',
      aboutus_content: '',
      aboutus_imgup_url: '',
      aboutus_imgdown_url: '',
      aboutus_is_show: true,
      aboutus_img_url: [],
      //课程体系
      homepageSystem: [],
      system_title_one: '',
      system_title_two: '',
      system_title_content: '',
      system_is_show: true,
      //课程理念
      ideaData: [],
      idea_is_show: true,
      //校园简介
      schoolData: [],
      //师资力量
      homepageTeacher: [],
      teacher_title_one: '',
      teacher_title_two: '',
      teacher_is_show: true,
      //校园新闻
      homepageNews: [],
      news_title_one: '',
      news_title_two: '',
      news_is_show: true,

      //学编程的好处
      homepageWhyLearn: [],
      whylearn_title_one: '',
      whylearn_title_two: '',
      whylearn_is_show: true,
      //照片墙
      homepageStu: [],
      stu_title_one: '',
      stu_title_two: '',
      stu_is_show: true,
      //大咖推荐
      is_show_recommend: true,
      //常见问题
      is_show_problem: true,
      //FOOTER
      homepageFooterMatch: [],
      aboutusData: [],
      contantData: [],
      qrcodeData: [],
      footer_match_title: '',
      footer_is_show: true,
      system_content: '',
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
  },

  mounted() {
    getHomepage().then((res) => {
      console.log('首页信息')
      console.log(res, '首页信息')

      const data = res.homepageData
      this.homepageBanner = data.homepageBanner
      this.homepage_id = data.homepage.id
      if (data.homepage.self_header_button) {
        this.self_header_button = data.homepage.self_header_button
      } else {
        this.self_header_button = []
      }
      this.is_show_banner_button = data.homepage.is_show_banner_button
      console.log(this.is_show_banner_button, 4757)
      this.logo_img = data.homepage.logo_img_url
      this.contant_img = data.homepage.modal_img_url
      this.is_show_copy_right = data.homepage.is_show_copy_right
      //关于我们
      this.aboutus_title_one = data.homepage.aboutus_title_one
      this.aboutus_title_two = data.homepage.aboutus_title_two
      this.aboutus_content = data.homepage.aboutus_content
      this.aboutus_imgup_url = data.homepage.aboutus_imgup_url
      this.aboutus_imgdown_url = data.homepage.aboutus_imgdown_url
      this.aboutus_is_show = data.homepage.aboutus_is_show
      this.aboutus_img_url = data.homepage.aboutus_img_url
      //课程体系
      this.homepageSystem = data.homepageSystem
      this.system_title_one = data.homepage.system_title_one
      this.system_title_two = data.homepage.system_title_two
      this.system_content = data.homepage.system_content
      this.system_is_show = data.homepage.system_is_show
      //课程理念
      this.ideaData.push(data.homepage.idea_title_one)
      this.ideaData.push(data.homepage.idea_title_two)
      this.ideaData.push(data.homepage.idea_img_url)
      this.ideaData.push(data.homepage.idea_one_title)
      this.ideaData.push(data.homepage.idea_one_content)
      this.ideaData.push(data.homepage.idea_two_title)
      this.ideaData.push(data.homepage.idea_two_content)
      this.ideaData.push(data.homepage.idea_three_title)
      this.ideaData.push(data.homepage.idea_three_content)
      this.ideaData.push(data.homepage.idea_four_title)
      this.ideaData.push(data.homepage.idea_four_content)
      this.idea_is_show = data.homepage.idea_is_show
      //校园环境
      this.schoolData.push(data.homepage.everment_title_one)
      this.schoolData.push(data.homepage.everment_title_two)
      this.schoolData.push(data.homepage.everment_img_url)
      this.schoolData.push(data.homepage.evermen_one_title)
      this.schoolData.push(data.homepage.evermen_one_content)
      this.schoolData.push(data.homepage.evermen_two_title)
      this.schoolData.push(data.homepage.evermen_two_content)
      this.schoolData.push(data.homepage.evermen_three_title)
      this.schoolData.push(data.homepage.evermen_three_content)
      //师资力量
      this.homepageTeacher = data.homepageTeacher
      this.teacher_title_one = data.homepage.teacher_title_one
      this.teacher_title_two = data.homepage.teacher_title_two
      this.teacher_is_show = data.homepage.teacher_is_show
      //校园新闻
      this.homepageNews = data.homepageNews
      this.news_title_one = data.homepage.news_title_one
      this.news_title_two = data.homepage.news_title_two
      this.news_is_show = data.homepage.news_is_show
      //学习编程好处
      this.homepageWhyLearn = data.homepageWhyLearn
      this.whylearn_title_one = data.homepage.whylearn_title_one
      this.whylearn_title_two = data.homepage.whylearn_title_two
      this.whylearn_is_show = data.homepage.whylearn_is_show

      //学员照片
      this.homepageStu = data.homepageStu
      this.stu_title_one = data.homepage.stu_title_one
      this.stu_title_two = data.homepage.stu_title_two
      this.stu_is_show = data.homepage.stu_is_show
      //大咖推荐
      this.is_show_recommend = data.homepage.is_show_recommend
      //常见问题
      this.is_show_problem = data.homepage.is_show_problem
      //FOOTER
      this.homepageFooterMatch = data.homepageFooterMatch
      this.footer_is_show = data.homepage.footer_is_show
      this.aboutusData.push(data.homepage.footer_aboutus_title)
      this.aboutusData.push(data.homepage.footer_aboutus_content)
      this.contantData.push(data.homepage.footer_contact_title)
      this.contantData.push(data.homepage.footer_contact_address)
      this.contantData.push(data.homepage.footer_contact_tel)
      this.contantData.push(data.homepage.footer_contact_wechat)
      this.qrcodeData.push(data.homepage.footer_wx_title)
      this.qrcodeData.push(data.homepage.footer_wx_img_url)
      this.footer_match_title = data.homepage.footer_match_title
    })
  },
}
</script>

<style scoped lang="scss">
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.wrapper {
  min-height: calc(100% - 30px);

  margin: 10px;
  border-radius: 5px;
  background: white;

  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
